import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';
import {LazyLoadImage} from "react-lazy-load-image-component";
import Img from "../../images/services-usa/and/banner-and.webp";


function Banner(props) {
    return (
        <div className="service_usa" style={{ backgroundColor: '#281d40' }}>
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                        <div className="banenr_content">
                        <h1><span>Startup Prototype</span> Development Company</h1>
                            <p>Discover the potential of your product idea with a pioneering Startup Prototype Development Company. TekRevol focus in creating prototypes that validate ideas and attract investors. Our team revolutionizes visions into perceptible prototypes, guaranteeing your startup is poised for success. Move confidently from concept to reality with our skilled prototype development services.</p>
                             <Link to="/contact"
                                  className="border_btn" aria-label="TekRevol Contact">Innovate Now!</Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-auto">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Tekrevol" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;